import { render, staticRenderFns } from "./PanelText.vue?vue&type=template&id=60b81136&"
import script from "./PanelText.vue?vue&type=script&lang=js&"
export * from "./PanelText.vue?vue&type=script&lang=js&"
import style0 from "./PanelText.vue?vue&type=style&index=0&id=60b81136&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60b81136')) {
      api.createRecord('60b81136', component.options)
    } else {
      api.reload('60b81136', component.options)
    }
    module.hot.accept("./PanelText.vue?vue&type=template&id=60b81136&", function () {
      api.rerender('60b81136', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/panels/PanelText.vue"
export default component.exports